<template>
  <div class="modal-overflow">
    <div v-if="loading" style="text-align: center;">
      <img src="static/img/loading-2.gif" />
    </div>
    <div v-else>
      <el-table class="table-striped wrap-whole-words indexed-table-column-width"
                :data="forms"
                border
                style="width: 100%"
                :max-height="tableHeight(350)">
        <el-table-column
          :width="this.constants.INDEX_COLUMN_WIDTHS.WIDE"
          align="center"
          label="#"
          type="index">
        </el-table-column>
        <el-table-column label="Name" width="300" sortable :sort-method="(a, b) => callStringSort(a, b)" prop="name">
          <template slot-scope="props">
            <span class="invisible">File ID: {{ props.row._id }}</span>
            {{ props.row.name }}
          </template>
        </el-table-column>
        <el-table-column label="Uploaded By" width="200" sortable :sort-method="(a, b) => callStringSort(a, b, 'uploadedByLabel')">
          <template slot-scope="props">
            {{ props.row.uploadedByLabel }}
          </template>
        </el-table-column>
        <el-table-column label="# Downloads" width="150" prop="downloadCount">
          <template slot-scope="props">
            {{ props.row.downloadCount }}
          </template>
        </el-table-column>
        <el-table-column label="Uploaded Date" width="175" prop="updatedAt">
          <template slot-scope="props">
            {{ props.row.updatedAt | formatDate }}
          </template>
        </el-table-column>
        <el-table-column label="Last Used" width="175" prop="lastUsedAt">
          <template slot-scope="props">
            {{ props.row.lastUsedAt | formatDate }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="canEdit"
          width="100"
          fixed="right"
          class="el-table__fixed"
          label="Actions">
          <template slot-scope="props">
            <p-button type="danger" size="sm" icon @click="confirmDelete(props.row)">
              <i class="fa fa-times"></i>
            </p-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import {NO_CONTENT, OK} from 'http-status-codes'
import {notifyError, notifySuccess, objectById, stringSort, getTableHeight} from 'src/utilities/utils'
import {mapGetters} from 'vuex'
import _ from 'lodash'
import Constants from 'src/utilities/constants'

export default {
  props: ['data'],
  computed: {
    ...mapGetters({
      users: 'users/results'
    }),
    canEdit() {
      return true
    }
  },
  data() {
    return {
      forms: [],
      loading: true,
      toDelete: null,
      constants: Constants
    }
  },
  methods: {
    closeModal () {
      this.loading = true
      this.$emit('close')
    },
    displayName(userId) {
      const user = objectById(this.users, userId)
      if (user) {
        return user.name
      }
      return ''
    },
    callStringSort(a, b, prop) {
      return stringSort(a, b, prop)
    },
    tableHeight(buffer) {
      return getTableHeight(buffer)
    },
    async confirmDelete(file) {
      const message = 'Are you sure you want to delete <strong>' + file.name + '</strong>? This will completely remove the inspection form.'

      this.toDelete = file
      const payload = {
        message,
        entity: file,
        delete: this.delete,
        showButton: true,
      }
      this.$eventHub.$emit('show-modal-2', 'Confirm Delete', payload, '600px')
    },
    async delete() {
      const response = await this.$store.dispatch('files/inspectionForms/deleteOne', this.toDelete)
      if (NO_CONTENT === response.status) {
        notifySuccess(this, 'Form Deleted Successfully')
        this.forms = _.filter(this.forms, (form) => form.id !== this.toDelete.id)
        this.toDelete = null
      } else {
        notifyError(this, 'Error Deleting File')
      }
    }
  },
  async mounted() {
    const response = await this.$store.dispatch('files/inspectionForms/fetchUnassociated')

    if (OK === response.status) {
      this.loading = false
      this.forms = response.data
    }
  }
}
</script>

